import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ClientSideRowModelModule, themeQuartz} from 'ag-grid-community';

import "./Table.css";

const defaultColors = {
  backgroundColor: '#ffffff',
  foregroundColor: '#332d3c',
  headerTextColor: '#332d3c',
  headerBackgroundColor: '#ffffff',
  oddRowBackgroundColor: 'rgba(0, 0, 0, 0.0)',
  headerColumnResizeHandleColor: '#7e2e84',
  rowBorder: { style: 'dotted', width: 0, color: '#9696C8' },
  wrapperBorder: { style: 'solid', width: 2, color: '#332d3c' },
  headerRowBorder: { style: 'solid', width: 0, color: '#332d3c' },
};

const Table = ({ columnDefs, rowData, colors = {} }) => {
  const themeColors = { ...defaultColors, ...colors };

  const myTheme = themeQuartz.withParams({
    backgroundColor: themeColors.backgroundColor,
    foregroundColor: themeColors.foregroundColor,
    headerTextColor: themeColors.headerTextColor,
    headerBackgroundColor: themeColors.headerBackgroundColor,
    oddRowBackgroundColor: themeColors.oddRowBackgroundColor,
    headerColumnResizeHandleColor: themeColors.headerColumnResizeHandleColor,
    rowBorder: themeColors.rowBorder,
    wrapperBorder: themeColors.wrapperBorder,
    headerRowBorder: themeColors.headerRowBorder,
  });

  const onGridReady = (params) => {
    setTimeout(() => params.api.resetRowHeights(), 100);
  };

  return (
    <div className="background">
      <div className="ag-grid-container">
        <AgGridReact
          suppressRowHoverHighlight={true}
          defaultColDef={{ resizable: false, wrapText: true, autoHeight: true }}
          columnDefs={columnDefs}
          rowData={rowData}
          theme={myTheme}
          domLayout="autoHeight"
          suppressRowVirtualisation={true}
          getRowId={(params) => params.data.word}
          modules={[ClientSideRowModelModule]}
          onGridReady={onGridReady}
        />
      </div>
    </div>
  );
};

export { Table }